require('./angular-cookie');
module.exports = 'ipCookie';



// WEBPACK FOOTER //
// ./~/angular-cookie/index.js